import { Stack, Typography } from "@mui/material";

interface AnalysisSelectionSummaryProps {
  growerLabel: string;
  siteLabel: string;
  trialLabel: string;
}

const AnalysisSelectionSummary: React.FC<AnalysisSelectionSummaryProps> = ({
  growerLabel,
  siteLabel,
  trialLabel,
}) => {
  const chunks = [
    { label: "Grower Boundary", value: growerLabel },
    { label: "Site", value: siteLabel },
    { label: "Trial", value: trialLabel },
  ];

  return (
    <Stack
      aria-label="Selected grower boundary, site, and trial"
      direction="row"
      role="list"
      spacing={2}
    >
      {chunks.map(({ label, value }) => (
        <Stack
          key={label}
          aria-label={`${label}: ${value}`}
          role="listitem"
          spacing={0}
          sx={{ flex: 1, minWidth: 0 }}
        >
          <Typography color="text.secondary" variant="caption">
            {label}
          </Typography>
          <Typography variant="body2">{value}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default AnalysisSelectionSummary;
